import * as Icons from "@mui/icons-material";

const MUIIcon = ({ name, onClick, size, color, sx }) => {
  const IconElement = Icons[name] || Icons.HelpOutline;

  const clickHandler = () => {
    if (onClick) onClick();
  };

  return (
    <>
      {onClick ? (
        <IconElement
          name={name}
          onClick={clickHandler}
          sx={{
            width: size ? size : null,
            height: "auto",
            cursor: onClick ? "pointer" : "default",
            color: color ? color : "inherit",
            ...sx,
          }}
        />
      ) : (
        <IconElement
          name={name}
          sx={{
            width: size ? size : null,
            height: "auto",
            color: color ? color : "inherit",
            ...sx,
          }}
        />
      )}
    </>
  );
};

export default MUIIcon;
